import React from 'react'
import styles from './DocumentView.module.scss'

export default function DocBody({ doc }) {
  if (doc.main_file_url) {
    return (
      <div className={styles.pdfWrap}>
        <div className={styles.pdfToolbar}>
          <span className={styles.pdfName}>
            📎 {doc.main_file_name || 'Документ'}
          </span>
          <a
            className={styles.pdfDownload}
            href={doc.main_file_url}
            target="_blank"
            rel="noreferrer"
          >
            ⬇ Скачать
          </a>
        </div>
        <iframe
          src={doc.main_file_url}
          className={styles.pdfFrame}
          title="Документ"
        />
      </div>
    )
  }

  if (doc.content) {
    return (
      <div className={styles.docBodyWrap}>
        <div
          className={styles.docContent}
          dangerouslySetInnerHTML={{ __html: doc.content }}
        />
      </div>
    )
  }

  return (
    <div className={styles.noContent}>
      <span>📭</span>
      <p>Содержание документа не заполнено</p>
    </div>
  )
}
